
import { LIVE_ELEMENT_CONTAINER } from "constants/widgetTypes.jsx";
import { getBaseStyles } from "../commonStyles";
import { cssUtil } from "../../utils/cssUtil";

const liveElementContext =  {};
export async function renderLiveElementWidget(context, widget, parent) {

    // Wrapper
    const element = context.document.createElement("div");
    element.classList.add("widget", "live_element_widget");
    const breakpoint = context.currentBreakpoint;

    const styles = getBaseStyles(widget, breakpoint);
    element.setAttribute("style", cssUtil.toStyleString(styles));
    element.setAttribute("data-widgetId", widget.uid);
    element.setAttribute("data-widgetType", widget.type);
    element.setAttribute("data-widgetParent", widget.parent);

    parent.appendChild(element);

    const widgets = widget?.children || [];

    if (!widgets.length) {
        return;
    }

    liveElementContext.widgets = widgets;
    liveElementContext.renderers = context.renderers;
    liveElementContext.document = context.document;
    liveElementContext.currentBreakpoint = context.currentBreakpoint;

    // Find container widget UIDs
    const containerIds = widgets
        .filter(w => w.type === LIVE_ELEMENT_CONTAINER)
        .map(w => w.uid);

    // Only render widgets whose parent is a container
    const childrenToRender = widgets.filter(w =>
        containerIds.includes(w.parent)
    );

    for (const child of childrenToRender) {
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false) continue;

        const renderer = liveElementContext.renderers[child.type];
        if (!renderer) continue;

        await renderer(liveElementContext, child, element);
    }

    return element;

}